export default __webpack_public_path__ + "static/media/aknc.7953f410.svg";